import "./topbar.css";

import { Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";

import { defaultStore } from "shared/common/stores/defaultStore";
import { topbarStore } from "shared/common/stores/topbarStore";
import Campaign from "./items/campaign/Campaign";
import DarkMode from "./items/darkMode/DarkMode";
import Help from "./items/help/Help";
import Language from "./items/language/Language";
import BackToPlatformModal from "./items/logo/BackToPlatformModal";
import { Logo } from "./items/logo/Logo";
import User from "./items/user/User";

interface props {
  role: string;
}

export default function Topbar({ role }: props) {
  const [showPlatformModal, setShowPlatformModal] = useState<boolean>(false);

  //close platform modal
  const handleClosePlatformModal = () => {
    setShowPlatformModal(false);
  };
  //redirect to platform link
  const redirectToPlatform = () => {
    window.location.href = "/";
  };

  return (
    <Box
      sx={{
        top: 0,
        position: "absolute",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          top: 0,
          gap: 1.5,
          padding: 0.5,
          justifyContent: "space-between",
        }}
        id="topbar"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: 2,
            flex: 1,
            minWidth: 0,
          }}
        >
          <IconButton
            onClick={() => {
              setShowPlatformModal(true);
            }}
            size="large"
            color="inherit"
            data-testid="logo"
            sx={{ width: "60px", height: "60px", padding: 1 }}
          >
            <Logo />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              alignItems: "center",
              flexDirection: "row",
              minWidth: "fit-content",
              display: "flex",
              gap: 2,
              paddingRight: 1,
            }}
          >
            <Campaign />
            <DarkMode />
            <Language />
            <Help role={role} />
          </Box>
          <User role={role} />
        </Box>
        {role !== "api" && (
          <BackToPlatformModal
            showPlatformModal={showPlatformModal}
            handleClose={handleClosePlatformModal}
            redirectToPlatform={redirectToPlatform}
          />
        )}
      </Box>
    </Box>
  );
}
